// extracted by mini-css-extract-plugin
module.exports = {"bkw-fix-tab":"FixTab_bkw-fix-tab__PU6Gr"};